// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/image/app/css/app.css
// module id = 604
// module chunks = 0